import { produce } from 'immer';

import {
  GET_SESSION_BY_ID,
  StreamingStatus,
  type QuerySessionResponse,
} from '../../contracts';
import { getSessionDataConfig } from '../config';
import { type SideBySideConsultNoteCandidateWithStream } from './types';

export function setConsultNoteFromCandidate(
  candidate: SideBySideConsultNoteCandidateWithStream,
  sessionId: string
) {
  // Extract the final result from the candidate's stream
  const finalResult = candidate.stream.map((chunk) => chunk.data).join('');

  // Update the session query data with the chosen candidate's result
  getSessionDataConfig()
    .getQueryClient()
    .setQueryData<QuerySessionResponse>([GET_SESSION_BY_ID, { sessionId }], (oldData) => {
      if (!oldData) return oldData;
      // Use immer produce to avoid large, complex and nested spread (...) logic
      return produce(oldData, (draft) => {
        draft.consult_note.result = finalResult;
        draft.streamingStatus = StreamingStatus.FINISHING_STREAMING;
      });
    });
}
